const DOUBLECLICK_SLOTS = {
    CST_MINI_BANNER_LEFT: 'CST_MINI_BANNER_LEFT',
    CST_MINI_BANNER_RIGHT1: 'CST_MINI_BANNER_RIGHT1',
    CST_MINI_BANNER_RIGHT2: 'CST_MINI_BANNER_RIGHT2',
    CST_MINI_BANNER_RIGHT3: 'CST_MINI_BANNER_RIGHT3',
    CST_MINI_BANNER_RIGHT4: 'CST_MINI_BANNER_RIGHT4',
    CST_MINI_BANNER_RIGHT5: 'CST_MINI_BANNER_RIGHT5',
};

const SIZE_BANNERS = {
    SMALL: [270, 225],
    MEDIUM: [564, 225],
    LARGE: [859, 106],
    MINI_HERO: [564, 235],
};

export { DOUBLECLICK_SLOTS, SIZE_BANNERS };
